import { useLayoutEffect } from "react";
import { useLocation } from "@tanstack/react-router";
import { hostKind } from "@/lib/hostKind";

/** Document boundaries include body portals; the console has utility density. */
export function usesApprovedDesign(pathname: string, host: string): boolean {
  return (
    !/^\/(welcome|canvas-demo)(\/|$)/.test(pathname) &&
    (host !== "admin" ||
      /^\/(super-admin|login|recovery|verify-email|reset-password|docs|me)(\/|$)/.test(
        pathname,
      ))
  );
}

export function visualSystemFor(pathname: string, host: string) {
  if (/^\/super-admin(\/|$)/.test(pathname)) return "platform";
  return usesApprovedDesign(pathname, host) ? "approved-v5" : undefined;
}

export function VisualSystem() {
  const { pathname } = useLocation();
  const system = visualSystemFor(pathname, hostKind());
  useLayoutEffect(() => {
    const root = document.documentElement;
    if (system) root.dataset.ui = system;
    else delete root.dataset.ui;
    root.dataset.surface = pathname === "/" ? "marketing" : "app";
    return () => {
      delete root.dataset.ui;
      delete root.dataset.surface;
    };
  }, [system, pathname]);
  return null;
}
